enum MissionRewardType {
  BONUS_OFFER = 'BonusOffer',
  VIRTUAL_CURRENCY = 'VirtualCurrency',
  LEVEL_BOOSTER = 'LevelBooster',
  MISSION_BOOSTER = 'MissionBooster',
  UNKNOWN = 'Unknown',
}

export default MissionRewardType
